import React, { useEffect } from 'react';

//Components
import { Button, Form } from 'react-bootstrap';

//Styles
import './styles.scss';

const not = (a, b) => {
    return a.filter((value) => b.indexOf(value) === -1);
}

const intersection = (a, b) => {
    return a.filter((value) => b.indexOf(value) !== -1);
}

const union = (a, b) => {
    return [...a, ...not(b, a)];
}

const ActivityDualList = props => {
    const { data, onSave } = props;

    const [checked, setChecked] = React.useState([]);
    const [left, setLeft] = React.useState([]);
    const [right, setRight] = React.useState([]);

    const leftChecked = intersection(checked, left);
    const rightChecked = intersection(checked, right);

    useEffect(() => {
        if (data) {
            setLeft(data.available)
            setRight(data.selected)
        }
    }, [data])

    const handleToggle = (value) => () => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    };

    const numberOfChecked = (items) => intersection(checked, items).length;

    const handleToggleAll = (items) => () => {
        if (numberOfChecked(items) === items.length) {
            setChecked(not(checked, items));
        } else {
            setChecked(union(checked, items));
        }
    };

    const handleCheckedRight = () => {
        const leftItems = not(left, leftChecked);
        const rightItems = right.concat(leftChecked);

        setRight(rightItems);
        setLeft(leftItems);
        setChecked(not(checked, leftChecked));
        onSave({ available: leftItems, selected: rightItems })
    };

    const handleCheckedLeft = () => {
        const leftItems = left.concat(rightChecked);
        const rightItems = not(right, rightChecked);

        setLeft(left.concat(rightChecked));
        setRight(not(right, rightChecked));
        setChecked(not(checked, rightChecked));
        onSave({ available: leftItems, selected: rightItems })
    };

    const customList = (title, items) => (
        <div className="dual-card">
            <div
                className={"dual-card-header"}
                onClick={handleToggleAll(items)}
                checked={numberOfChecked(items) === items.length && items.length !== 0}
                disabled={items.length === 0}
            >
                <Form.Group className="dual-checkbox-group">
                    <Form.Check
                        readOnly
                        checked={numberOfChecked(items) === items.length && items.length !== 0}
                        type="checkbox"
                        label={title}
                        disabled={items.length === 0}
                    />
                </Form.Group>
            </div>
            <hr className={"dual-divider"} />
            <div className={"dual-list"} >
                {items.map((value) => {
                    return (
                        <div key={value.id} className={"dual-list-item"} onClick={handleToggle(value)}>
                            <Form.Check
                                readOnly
                                checked={checked.indexOf(value) !== -1}
                                type="checkbox"
                                label={value.name}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );

    return (
        <div>
            <div spacing={2} justify="center" className={"dual-root"}>
                <div className="dual-grid-item">{customList('Disponibles', left)}</div>
                <div className="dual-grid-item">
                    <div className="dual-button-container">
                        <Button
                            variant="outlined"
                            size="small"
                            className={"dual-button"}
                            onClick={handleCheckedRight}
                            disabled={leftChecked.length === 0}
                            aria-label="move selected right"
                        >
                            &gt;
                        </Button>
                        <Button
                            variant="outlined"
                            size="small"
                            className={"dual-button"}
                            onClick={handleCheckedLeft}
                            disabled={rightChecked.length === 0}
                            aria-label="move selected left"
                        >
                            &lt;
                        </Button>
                    </div>
                </div>
                <div className="dual-grid-item">{customList('Seleccionados', right)}</div>
            </div>
        </div>
    )
};

export default ActivityDualList;
